import React from 'react'
import RoleManagementPage from '../../../../pages/Settings/RoleManagement'

export const RoleManagementFactory: React.FC = () => {
  return <RoleManagementPage />
}
